
<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17 12C17 11.4477 16.5523 11 16 11H8L7.88338 11.0067C7.38604 11.0645 7 11.4872 7 12C7 12.5523 7.44772 13 8 13H16L16.1166 12.9933C16.614 12.9355 17 12.5128 17 12Z"
    :fill="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
    :fill="color"
  />
</svg>
